"use client";

import { useMemo } from "react";

import type { UseMp3DataResult } from "../types";
import {
  shouldShowQrContentWrapper,
  shouldShowDownloadButton,
  shouldShowShareButton,
} from "../utils";
import { usePreviewData } from "@/features/previews/shared";
import { QRProps } from "@/contexts/QREditorContext/types";

export const useMp3Data = (props: QRProps<"mp3">): UseMp3DataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);

  // Computed values with useMemo for performance
  const { showQrContentWrapper, hasDownloadButton, hasShareButton, hasAudioFile, hasCustomButton } =
    useMemo(() => {
      if (!data) {
        return {
          showQrContentWrapper: false,
          hasDownloadButton: false,
          hasShareButton: false,
          hasAudioFile: false,
          hasCustomButton: false,
        };
      }

      return {
        showQrContentWrapper: shouldShowQrContentWrapper(data),
        hasDownloadButton: shouldShowDownloadButton(data, isInitialPreview),
        hasShareButton: shouldShowShareButton(data, isInitialPreview),
        hasAudioFile: Boolean(data.mp3FileUrl),
        hasCustomButton: Boolean(data.mp3ButtonText),
      };
    }, [data, isInitialPreview]);

  return {
    isInitialPreview,
    data,
    showQrContentWrapper,
    hasDownloadButton,
    hasShareButton,
    hasAudioFile,
    hasCustomButton,
  };
};
